module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script-Alt.e8721e44.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script-Alt.eot
// module id = 2245
// module chunks = 49